import { RefObject, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type {
  ActionEventArgs,
  ScheduleComponent,
} from '@syncfusion/ej2-react-schedule';
import {
  DefaultCalendarSetSelectedDate,
  DefaultCalendarSetView,
} from '../store';

// Alt+1..4: Syncfusion passa alla vista n-esima (Giorno, Settimana, Mese, Agenda).
const isVistaDaTastiera = (event: Event): boolean =>
  event instanceof KeyboardEvent && event.altKey;

/**
 * Gestore di actionBegin dello Scheduler. Le viste dell'agenda le comanda la barra
 * redux, ma Syncfusion cambia vista anche da sé: con Alt+1..4 e con il clic sulla
 * data nel Mese, in Agenda o nel popup degli altri appuntamenti, che porta al
 * Giorno. Senza questo controllo redux (barra, dati e fascia Presenze) resterebbe
 * sulla vista di prima.
 *
 * Questi cambi arrivano con l'evento che li ha causati e si annullano; quelli
 * guidati dalle prop (cambio di vista da redux) arrivano senza evento e passano.
 * Il passaggio al Giorno si rifà da redux, con la data che Syncfusion ha già
 * impostato. Alt+1..4 si annulla e basta: Giorno e Settimana di Syncfusion non
 * distinguono 3 Giorni e Lavorativo.
 */
export function useSchedulerViewNavigation(
  scheduleObj: RefObject<ScheduleComponent>
) {
  const dispatch = useDispatch();
  return useCallback(
    (args: ActionEventArgs) => {
      if (args.requestType !== 'viewNavigate' || !args.event) return;
      args.cancel = true;
      const schedule = scheduleObj.current;
      if (!schedule || isVistaDaTastiera(args.event)) return;
      dispatch(DefaultCalendarSetSelectedDate(schedule.selectedDate));
      dispatch(DefaultCalendarSetView('Day'));
    },
    [dispatch, scheduleObj]
  );
}
